import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox/checkbox';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ProductionListMapperI } from '../../models/production-list/production-list';
import * as moment from 'moment';

@Component({
  selector: 'anterasoftware-kanban-productions-list-view',
  templateUrl: './kanban-productions-list-view.component.html',
  styleUrls: ['./kanban-productions-list-view.component.scss']
})
export class KanbanProductionsListViewComponent implements OnInit {

  @ViewChild(MatSort) public sort: MatSort = {} as MatSort;

  @Input() public listDataSource: any[] = [];
  @Input() public displayedColumns: string[] = [];
  @Input() public pageSizeOptions: number[] = [];
  @Input() public tableLength: number = 0;
  @Input() public page: string = '';
  @Input() public displayActionsBar: boolean = false;

  @Output() public selectClicked: EventEmitter<any> = new EventEmitter();
  @Output() public onColumnClick: EventEmitter<any> = new EventEmitter();
  @Output() public onPaginateFire: EventEmitter<any> = new EventEmitter();
  @Output() public onSortFired: EventEmitter<any> = new EventEmitter();

  public dataSource: any;
  public selectAll: boolean = false;

  public pageSize: number = 50;
  @Input() public dateFormatString: string = 'DD/MM/YYYY';
  @Input() public timeFormatString: string = 'hh:mm a';

  constructor() { 
    console.log("KanbanProductionsListViewComponent Hello")
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource(this.listDataSource);
    console.log("this.dataSource",this.dataSource)
    this.appendColumns();
  }

  public ngOnChanges() {
    this.appendColumns();
    this.dataSource = new MatTableDataSource(this.listDataSource);
  }

  public appendColumns(){
    const standardColumns = ['select']

    standardColumns.forEach((colName) => {
      if(!this.displayedColumns?.includes(colName)){
        this.displayedColumns.unshift(colName);
      }
    });
  }

  /**
   * Toggles, so all checkboxes are selected.
   *
   * @returns {void}
   */
  public toggleAll(selectType: string, checkbox?: MatCheckbox, selectedRow?: ProductionListMapperI ): void {

    switch (selectType){
      case 'SINGLE':
        this.dataSource.data.find((row: ProductionListMapperI) => row.id === selectedRow?.id).select = checkbox?.checked;
      break;
      case 'FIRST_50':
        // Special scenario need to ask bhavesh how to distinguish all and first 50.
        this.selectAll = true;
        this.dataSource.data.forEach((data: ProductionListMapperI) => (data.select = true));
      break;
      case 'SELECT_ALL':
          // Special scenario need to ask bhavesh how to distinguish all and first 50.
         this.selectAll = true;
         this.dataSource.data.forEach((data: ProductionListMapperI) => (data.select = true));
      break;
      case 'DESELECT_ALL':
          this.selectAll = false;
          this.dataSource.data.forEach((data: ProductionListMapperI) => (data.select = false));
      break;
      case 'SELECT_ALL_TOGGLE':
          this.selectAll = !this.selectAll;
          this.dataSource.data.forEach((data: ProductionListMapperI) => (data.select = this.selectAll));
          selectType = this.selectAll ? 'SELECT_ALL' : 'DESELECT_ALL';
      break;
      default:
          this.selectAll = !this.selectAll;
          this.dataSource.data.forEach((data: ProductionListMapperI) => (data.select = this.selectAll));
      break;
    }

    this.selectClicked.emit({data: this.dataSource.data, selectType});
  }

  /**
   * On column click, emit the colum name and the row selected.
   *
   * @param {ProductionListMapperI} element
   * @param {string} columnName
   * @returns {void}
   */
   public onColumnClicked(element: ProductionListMapperI, columnName: string): void {
    this.onColumnClick.emit({ columnName, rowSelected: element });
  }

  /**
   * On paginate emit event;
   *
   * @returns {void}
   */
  public paginate(event: any) {
    const paginateObj = {
      offset: event.pageIndex,
      limit: event.pageSize,
    };

    this.pageSize = event.pageSize;
    this.onPaginateFire.emit(paginateObj);
  }


  /**
   * On material sort fire event.
   *
   * @returns {void}
   */
  public onListViewSort(event: Sort) {
    this.onSortFired.emit(event);
  }

  public getDateFormat(date :any, includeTime = false, excludeTime = false, convert = false){
    if(date == null || date == '' || date == '0000-00-00 00:00:00' || date == '0000-00-00' || date == '0000-00-00' || (String(date).indexOf("0000") > -1 && String(date).indexOf("+0000") < 0 )){
        return '';
    }
    if(convert){
      if(includeTime){
    return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(moment.utc(date).local().toDate()).format(this.dateFormatString);
    }
      }          
    }else{
      if(includeTime){
    return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
      }else{
    if(String(date).length > 10 && !excludeTime){
        return moment(date).format(this.dateFormatString+' '+this.timeFormatString);
    }else{
        return moment(date).format(this.dateFormatString);
    }
      }      
    }
  }
}
